import { Button } from '@mui/material';
import SellRounded from '@mui/icons-material/SellRounded';
import { Link as RouterLink } from 'react-router';
import { MyBilling } from '@/platform/billing/MyBilling';
import { useSession } from '@/platform/session';
import { PageHeader } from '../PageHeader';

/** Coordinators: the plan, invoices and history of their institutions. */
export function BillingPage() {
  const { refresh } = useSession();
  return (
    <>
      <PageHeader
        title="Plano e pagamentos"
        subtitle="O plano da sua instituição, as faturas e tudo o que mudou."
        actions={
          <Button component={RouterLink} to="/planos" target="_blank" startIcon={<SellRounded />}>
            Ver todos os planos
          </Button>
        }
      />
      <MyBilling onChanged={() => void refresh()} />
    </>
  );
}
